import "./Checkbox.scss";

import cx from "classnames";
import { Tooltip } from "components/Tooltip/Tooltip";
import type { DetailedHTMLProps, InputHTMLAttributes } from "react";
import React from "react";
import type { FieldErrors } from "react-hook-form";

export type CheckboxProps<T = unknown> = {
  label: string;
  name: string;
  readOnly?: boolean;
  disabledReason?: string;
  isFocused?: boolean;
  errors?: FieldErrors<T>;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps<unknown>>(
  (
    { label, name, readOnly, disabledReason, isFocused, errors, ...rest },
    ref,
  ) => {
    const error = errors?.[name]?.message;
    const checkboxContent = (
      <>
        <label htmlFor={name}>{label}</label>
        <Tooltip
          variant={error ? "error" : undefined}
          content={error || (readOnly ? disabledReason : undefined)}
        >
          <input
            id={name}
            name={name}
            disabled={readOnly}
            type="checkbox"
            ref={ref}
            className={cx({ "input--error": error })}
            {...rest}
          />
        </Tooltip>
      </>
    );

    return (
      <div
        className={cx("checkbox", {
          "checkbox--Focused": isFocused,
          "checkbox--Error": error,
        })}
      >
        {readOnly && disabledReason ? <>{checkboxContent}</> : checkboxContent}
      </div>
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
